module.exports = __webpack_public_path__ + "static/media/o_config_refresh-arrow.8699e694.svg";